import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NumberInputDirective } from '@shared/directives';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { isMobileView } from '@core/utils';
import { CourseFormComposition } from '@shared/compositions';
import { CourseInstructorType, SectionType, TaskType, Visibility } from '@core/enums';
import { DatePickerInputComponent, FormErrorComponent, TimePickerInputComponent } from '@shared/components';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent, SimpleFileSelectorInputComponent } from '@shared/components/ui';
import { TippyModule } from '@ngneat/helipopper';

@Component({
  selector: 'app-course-form',
  imports: [
    CommonModule,
    IconComponent,
    ButtonComponent,
    DatePickerInputComponent,
    DropdownComponent,
    FormErrorComponent,
    FormsModule,
    ImageSelectorComponent,
    NgSelectModule,
    NumberInputDirective,
    ReactiveFormsModule,
    TimePickerInputComponent,
    TranslateModule,
    TippyModule,
    SimpleFileSelectorInputComponent,
  ],
  templateUrl: './course-form.component.html',
  styleUrls: ['./course-form.component.scss'],
})
export class CourseFormComponent extends CourseFormComposition implements OnInit {
  protected readonly isMobileView = isMobileView;
  protected readonly EventVisibility = Visibility;
  protected readonly TasksType = TaskType;
  protected readonly EventTaskType = TaskType;
  protected readonly CourseInstructorType = CourseInstructorType;
  protected readonly SectionType = SectionType;
  private readonly _route = inject(ActivatedRoute);

  constructor() {
    super();
    const courseId = this._route.snapshot.paramMap.get('id');
    if (courseId) {
      this.courseId = +courseId;
    }

    if (!isMobileView()) {
      this._currentSelectedCourse = this._dialogRef.data?.course;
    }
  }

  get isUpdateMode(): boolean {
    return !!(this._currentSelectedCourse && this._currentSelectedCourse.id && this._currentSelectedCourse?.imageUrl);
  }

  ngOnInit() {
    this._initDataForForm();
    if (this._dialogRef && this._dialogRef.data && this._dialogRef.data.course) {
      this._currentSelectedCourse = this._dialogRef.data.course;
    } else if (this._bottomSheetService && this._bottomSheetService.currentSheetData) {
      this._currentSelectedCourse = this._bottomSheetService.currentSheetData.course;
    }

    if (this._currentSelectedCourse && this._currentSelectedCourse.id) {
      this.courseId = this._currentSelectedCourse.id;
      // this._patchFormValues(this._currentSelectedCourse);
      this._fetchCourseDetails(this._currentSelectedCourse.id);
    }
  }
}
